{
  "common": {
    "labels": {
      "yes": "Yes",
      "no": "No",
      "status": "Status",
      "date": "Date",
      "customer": "Customer",
      "customers": "Customers",
      "viewAll": "View All",
      "viewAssigned": "View Assigned",
      "cost": "Cost",
      "price": "Price",
      "assign": "Assign",
      "reassign": "Reassign",
      "code": "Code",
      "day": "Day",
      "days": "Days",
      "onward": "Onward",
      "product": "Product",
      "products": "Products",
      "logo": "Logo",
      "alias": "Alias",
      "website": "Website",
      "admin": "Admin",
      "adminUser": "Admin User",
      "title": "Title",
      "description": "Description",
      "image": "Image",
      "none": "None",
      "all": "All",
      "index": "Index",
      "quantity": "Quantity",
      "category": "Category",
      "categories": "Categories",
      "subCategory": "Sub Category",
      "listOrder": "List Order",
      "order": "Order",
      "type": "Type",
      "group": "Group",
      "optional": "Optional",
      "step": "Step",
      "departments": "Departments",
      "branch": "Branch",
      "searchBranch": "Search Branch",
      "currency": "Currency",
      "requoteMarkup": "Requote Markup",
      "license": "License",
      "processingLevels": "Processing Levels",
      "profilePhoto": "Profile Photo",
      "noLogin": "No Login",
      "value": "Value",
      "notes": "Notes",
      "accountCode": "Account Code",
      "accountEnabled": "Account Enabled",
      "optionHeadings": "Option Headings",
      "optionItems": "Option Items",
      "previewChanges": "Preview Changes",
      "customerType": "Customer Type",
      "error": "Error",
      "createdAt": "Created At",
      "source": "Source",
      "reference": "Reference",
      "surveySheet": "Survey Sheet",
      "statusIs": "Status {is} {status}",
      "verificationIs": "Verification {is} {status}",
      "licenseIs": "License {is} {status}",
      "categoryIs": "Category {is} {status}",
      "subCategoryIs": "Sub Category {is} {status}",
      "is": "is",
      "isBetween": "is between",
      "and": "and",
      "number": "Number",
      "retail": "Retail",
      "commercial": "Commercial",
      "newBuild": "New Build",
      "trade": "Trade",
      "miles": "Miles",
      "surveyor": "Surveyor",
      "fitter": "Fitter",
      "sales": "Sales",
      "notRequired": "Not Required",
      "contract": "Contract",
      "enquiry": "Enquiry",
      "quote": "Quote",
      "item": "Item",
      "colour": "Colour",
      "basket": "Basket",
      "filter": "Filter",
      "square": "Square",
      "squares": "Squares",
      "facets": "facets",
      "qty": "Qty",
      "extras": "Extras",
      "stockExtras": "Stock Extras",
      "nonStockExtras": "Non Stock Extras",
      "freeTypedExtras": "Free Typed Extras",
      "view": "View",
      "summary": "Summary",
      "name": "Name",
      "document": "Document",
      "features": "Features",
      "licenseStatus": "License Status",
      "discount": "Discount",
      "limit": "Limit",
      "verification": "Verification",
      "base": "Base",
      "full": "Full",
      "default": "Default",
      "options": "Options",
      "expiryDate": "Expiry Date",
      "optionGroups": "Option Groups",
      "inside": "Inside",
      "outside": "Outside",
      "pleaseSelect": "Please Select",
      "size": "Size",
      "subject": "Subject",
      "new": "New",
      "extra": "Extra",
      "currentOfTotal": "{current} of {total}"
    },
    "buttons": {
      "save": "Save Changes",
      "saveOption": "Save {option}",
      "cancel": "Cancel",
      "replace": "Replace",
      "remove": "Remove",
      "DragDrop": "Drag & drop",
      "browse": "Browse",
      "goBack": "Go Back",
      "continue": "Continue",
      "update": "Update",
      "add": "Add",
      "delete": "Delete",
      "confirm": "Confirm",
      "submit": "Submit",
      "import": "Import",
      "revert": "Revert",
      "undo": "Undo",
      "rename": "Rename",
      "reorder": "Reorder",
      "reset": "Reset",
      "confirmAndSave": "Confirm & Save",
      "create": "Create",
      "readMore": "Read More",
      "addAddress": "Add Address",
      "editAddress": "Edit Address",
      "refreshRequired": "Refresh Required",
      "accept": "Accept",
      "refuse": "Refuse",
      "reload": "Reload",
      "refresh": "Refresh",
      "close": "Close",
      "ok": "Ok",
      "complete": "Complete",
      "edit": "Edit",
      "duplicate": "Duplicate",
      "clearSearch": "Clear Search",
      "clearFilter": "Clear Filter",
      "back": "Back",
      "expandAll": "Expand All",
      "collapseAll": "Collapse All",
      "clickHere": "Click here",
      "next": "Next",
      "prev": "Prev",
      "addNew": "Add New",
      "addFile": "Add File",
      "addVideo": "Add Video",
      "select": "Select",
      "finish": "Finish",
      "saveShort": "Save",
      "loadMore": "Load More",
      "retry": "Retry",
      "backToHome": "Back To Home",
      "decline": "Decline",
      "sending": "Sending",
      "emailSent": "Email Sent",
      "resendEmail": "Resend Email",
      "start": "Start",
      "download": "Download",
      "proceed": "Proceed",
      "watch": "Watch",
      "send": "Send",
      "discard": "Discard",
      "enableAll": "Enable all"
    },
    "validation": {
      "passwordsNoMatch": "Passwords do not match",
      "delete": "Are you sure you want to delete {item}?",
      "unSavedChanges": "There are unsaved changes",
      "unSavedChangesQuery": "You have unsaved changes. Are you sure you want to leave without saving?",
      "confirmSaveText": "Changes made will be published to live instantly. Are you sure you want to save?",
      "confirmSave": "Confirm Save",
      "noResults": "No results found",
      "noProductsFound": "No Products Found",
      "invalidData": "Invalid Data",
      "widthMustDiffer": "Width minimum and maximum must differ",
      "heightMustDiffer": "Height minimum and maximum must differ",
      "contractSaveTimeout": "Contract save is taking longer than expected. Please refresh the page to see the latest status.",
      "cannotBeUndone": "This action cannot be undone.",
      "notRecoverable": "This will not be recoverable.",
      "referenceRequired": "Please enter a reference",
      "urlAndFileConflict": "Cannot define both a URL and a file. Please choose one.",
      "areYouSure": "Are you sure?",
      "addressAlreadyExists": "This address already exists for this customer.",
      "pleaseCheckInput": "Please Check Your Input",
      "validationErrors": "Validation Errors",
      "validationErrorsOccurred": "One or more validation errors have occurred",
      "pleaseTryAgain": "Please try again.",
      "unSavedChangesForm": "There are unsaved changes in this form",
      "invalidFileType": "Invalid file type! Only PNG or JPEG allowed.",
      "fileSizeExceeded": "File size exceeds the maximum limit of {mb} MB.",
      "notRecognisedAsNumber": "{value} not recognised as a number",
      "rules": {
        "required": "{field} is required",
        "requiredMultiple": "At least one {field} is blank",
        "email": "{field} must be a valid email address",
        "maxLength": "{field} must not exceed {max} characters",
        "minLength": "{field} must be at least {min} characters",
        "url": "{field} must be a valid URL",
        "numeric": "{field} must be a number",
        "numericMultiple": "At least one {field} is not a number",
        "wholeNumber": "{field} must be a whole number",
        "min": "{field} must be at least {min}",
        "minMultiple": "At least one {field} is below the minimum of {min}",
        "max": "{field} must not exceed {max}",
        "belowMinimum": "{value}mm is {diff}mm below the minimum",
        "aboveMaximum": "{value}mm is {diff}mm above the maximum",
        "pattern": "{field} is in an invalid format",
        "maxPostCodePrefixLength": "Max 4 Letters Per Post Code Prefix"
      }
    },
    "global": {
      "cookieTitle": "Cookie Notice",
      "cookieText": "This website collects cookies to deliver better user experience, We collect cookies to analyse our website traffic and performance; we never collect any personal data unless agreed at point of collection and we will notify you in advance.",
      "search": "Search {item}...",
      "requiredFileType": "Required file type: {fileTypes}",
      "recommendedImageSize": "Recommended size: {width}px x {height}px.",
      "imageRatioRequired": "4:3 Ratio Required: E.g. 400 by 300 or 1200 by 900 etc.",
      "maxFileSize": "Max File Size: {mb}MB",
      "maintenanceTitle": "System under temporary maintenance",
      "maintenanceText": "Please check back soon",
      "maintenanceSorryText": "Sorry for the inconvenience. Please check back soon.",
      "newVersionTitle": "New version available",
      "newVersionText": "A new version of the application is available. Please refresh the page to update.",
      "needHelpCallUs": "Need help? Call us on {phoneNumber}",
      "questionCallUs": "Got a question? Please call us on {phoneNumber}",
      "privacyPolicy": "privacy policy",
      "privacyPolicyName": "Privacy Policy",
      "termsAndConditions": "terms & conditions",
      "termsAndConditionsName": "Terms and Conditions",
      "privacyPolicyInfo": "{clickHere} for more information about how we will use your personal information.",
      "termsAndConditionsInfo": "{clickHere} to view our terms and conditions.",
      "importantNotice": "Important Notice"
    },
    "menu": {
      "home": "Home",
      "customers": "Customers",
      "branch": "Branch",
      "branches": "Branches",
      "dashboard": "Dashboard",
      "viewEnquiries": "View Enquiries",
      "enquiries": "Enquiries",
      "viewQuotes": "View Quotes",
      "viewOrders": "View Orders",
      "orders": "Orders",
      "quotes": "Quotes",
      "createQuote": "Create Quote",
      "createOrder": "Create Order",
      "pendingOrders": "Pending Orders",
      "placedOrders": "Placed Orders",
      "cancelledOrders": "Cancelled Orders",
      "resourceCentre": "Resource Centre",
      "news": "News",
      "store": "{touch} Store",
      "support": "Quick Support",
      "setup": "Setup",
      "account": "Account",
      "staff": "Staff",
      "styling": "Styling",
      "productSettings": "Product Settings",
      "general": "General",
      "selections": "Selections",
      "requoteMarkups": "Requote Markups",
      "alternateSashOverlaps": "Alternate Sash Overlaps",
      "alternateGlassClearance": "Alternate Glass Clearance",
      "costsPrices": "Costs/Prices",
      "pricingSetup": "Pricing Setup",
      "financialCategories": "Financial Categories",
      "discountCategories": "Discount Categories",
      "partsList": "Parts List",
      "glass": "Glass",
      "panel": "Panel",
      "slabGlassBands": "Slab Glass Bands",
      "slab": "Slab",
      "labour": "Labour",
      "costList": "Cost List",
      "priceList": "Price List",
      "product": "Product",
      "company": "Company",
      "products": "Products",
      "deployment": "Deployment",
      "delivery": "Delivery",
      "retailOptionControl": "Retail Option Control",
      "details": "Details",
      "settings": "Settings",
      "imagesAndText": "Images & Text",
      "emails": "Emails",
      "paperwork": "Paperwork",
      "paymentGateway": "Payment Gateway",
      "specifications": "Catalogue Specifications",
      "defaults": "Defaults",
      "productSpecifications": "Specifications",
      "productDefaults": "Defaults",
      "availability": "Availability",
      "brandedMode": "{brandedMode}",
      "knowledgeBase": "Knowledge Base",
      "charges": "Charges",
      "leadTimes": "Lead Times",
      "options": "Options",
      "customerManagement": "Customer Management",
      "salesDashboard": "Sales Dashboard",
      "basket": "Basket",
      "chooseProduct": "Choose Product",
      "chooseExtras": "Choose Extras",
      "switchDesign": "Switch Design",
      "manageNews": "Manage News",
      "processingOptions": "Processing Options",
      "vouchers": "Vouchers",
      "discounts": "Discounts",
      "analytics": "Analytics",
      "nonStockExtras": "Non Stock Extras"
    },
    "status": {
      "pending": "Pending",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "mandatory": "Mandatory",
      "live": "Live",
      "archived": "Archived",
      "active": "Active",
      "expired": "Expired",
      "expiring": "Expiring",
      "off": "Off",
      "on": "On",
      "saving": "Saving",
      "loading": "Loading",
      "notFound": "Not Found",
      "cancelled": "Cancelled",
      "notStarted": "Not Started",
      "started": "Started",
      "failed": "Failed",
      "na": "N/A",
      "downloaded": "Downloaded",
      "imported": "Imported",
      "placed": "Placed",
      "saved": "Saved",
      "awaiting": "Awaiting",
      "success": "Success",
      "saveSuccessful": "Save Successful",
      "saveFailed": "Save Failed",
      "placedPendingPayment": "Placed (Pending Payment)",
      "notSelected": "not selected",
      "notGrouped": "Not Grouped",
      "verified": "Verified",
      "accepted": "Accepted",
      "declined": "Declined",
      "redeemed": "Redeemed",
      "onStop": "On Stop",
      "refused": "Refused",
      "deleteSuccessful": "Delete Successful",
      "copyFailed": "Copy Failed",
      "copiedToClipboard": "Copied to Clipboard",
      "processing": "Processing",
      "setupComplete": "Setup Complete",
      "notSent": "Not Sent",
      "sent": "Sent",
      "unknown": "Unknown"
    },
    "datetime": {
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday",
      "mo": "Mo",
      "tu": "Tu",
      "we": "We",
      "th": "Th",
      "fr": "Fr",
      "sa": "Sa",
      "su": "Su",
      "mon": "Mon",
      "tues": "Tues",
      "wed": "Wed",
      "thurs": "Thurs",
      "fri": "Fri",
      "sat": "Sat",
      "sun": "Sun",
      "dateBetween": "Date {isBetween} {from} {and} {to}",
      "startDate": "Start Date",
      "endDate": "End Date",
      "startEndDate": "Start / End Date",
      "dateRange": "Date Range",
      "minute": "minute",
      "minutes": "minutes",
      "time": "Time",
      "hr": "hr",
      "hrs": "hrs"
    },
    "contact": {
      "name": "Name",
      "company": "Company",
      "contactNumber": "Contact Number",
      "salesContact": "Sales Contact",
      "firstName": "First Name",
      "lastName": "Last Name",
      "email": "Email",
      "emailAddress": "Email Address",
      "phone": "Phone",
      "phoneNumber": "Phone Number",
      "address": "Address",
      "address1": "Address Line 1",
      "address2": "Address Line 2",
      "address3": "Address Line 3",
      "postcode": "Postcode",
      "country": "Country",
      "county": "County",
      "town": "Town",
      "line1": "Line 1",
      "line2": "Line 2",
      "line3": "Line 3",
      "primaryAddress": "Primary Address",
      "primary": "Primary",
      "deliveryAddress": "Delivery Address",
      "deliveryAddresses": "Delivery Addresses",
      "yourAddress": "Your Address",
      "addressPlaceholder": "Please enter your address...",
      "mobile": "Mobile",
      "tel": "Tel",
      "customerName": "Customer Name",
      "contactRoles": "Contact Roles"
    },
    "financial": {
      "subtotal": "Subtotal",
      "vat": "VAT",
      "perMonth": "per month",
      "poa": "POA",
      "foc": "FOC",
      "total": "Total",
      "defaultTaxRate": "Default Tax Rate",
      "taxRates": "Tax Rates",
      "payNow": "Pay Now",
      "priceExclTax": "Price (excl. Tax)",
      "updatePaymentStatus": "Update Payment Status",
      "updatePaymentStatusQuestion": "Are you sure you want to update payment status from <strong>{from}</strong> to <strong>{to}</strong>?<br>This action cannot be undone.",
      "tax": "Tax",
      "totalIncTax": "Total Inc Tax",
      "netSell": "Net Sell",
      "subtotalDiscounted": "Subtotal (Discounted)",
      "showFinancials": "Show Financials",
      "hideFinancials": "Hide Financials",
      "deliveryCharge": "Delivery Charge",
      "fittingCharge": "Fitting Charge",
      "surveyCharge": "Survey Charge",
      "productCharge": "Product Charge",
      "supplyFitExtrasCharge": "Supply & Fit Extras Charge",
      "supplyOnlyExtrasCharge": "Supply Only Extras Charge",
      "incVat": "(inc vat)",
      "excVat": "(exc vat)"
    },
    "errors": {
      "somethingWrong": "Oops! Something went wrong...",
      "forwardError": "Don't worry though, it's not your fault. Please let us know what happened so we can better understand the problem.",
      "provideFeedback": "Please provide feedback...",
      "submitFeedback": "Submit Feedback",
      "feedbackSubmitted": "Feedback submitted. Thank you!",
      "somethingWentWrong": "Something Went Wrong",
      "serverNotReached": "We're having trouble reaching our servers. Please check your connection or try again.",
      "pageNotFound": "Page not found.",
      "pageNotFoundLong": "The page you are looking for cannot be found.",
      "forbiddenError": "You don't have permission to access this resource.",
      "forbiddenErrorText": "If you believe this is a mistake, please try refreshing the page or log in again.",
      "logoNotFound": "[LOGO NOT FOUND]",
      "tooManyRequests": "Too Many Requests",
      "tooManyRequestsText": "You've made too many requests. Please wait a moment and try again."
    }
  },

  "features": {
    "login": {
      "productDescription": "Login here to manage {license} quotes, orders, products, news, resources and {retailType} enquiries.",
      "title": "Welcome back!",
      "description": "Continue to your dashboard",
      "password": "Password",
      "customerEmail": "Customer Email",
      "superuser": "Login as Super User",
      "forgotPassword": "Forgot your password? Click here!",
      "register": "Register for an Account",
      "cta": "Login",
      "logout": "Logout",
      "registerButton": "Register",
      "confirmPassword": "Confirm Password",
      "store": "{touch} Store",
      "forgotPasswordTitle": "Forgot your password?",
      "forgotPasswordSubtitle": "Enter your email address to reset it.",
      "returnToLogin": "Return to login",
      "resetPasswordTitle": "Reset your password",
      "resetPasswordSubtitle": "Enter a new password.",
      "resetPassword": "Reset Password",
      "passwordResetSent": "Password Reset Request Sent",
      "setPasswordTitle": "Set your password",
      "setPasswordSubtitle": "Enter a password.",
      "setPasswordHint": "Please provide a password for the account. This must be 8 characters in length as a minimum with at least one upper case letter, one lower case and one number.",
      "setPassword": "Set Password",
      "invalidToken": "Invalid Token",
      "newPassword": "New Password",
      "adminTitle": "QUOTILA Admin",
      "createAccount": "Create your Account",
      "stepsLabel": "In 4 simple steps",
      "step1": "Enter your details",
      "step2": "Verify your email address",
      "step3": "Wait to be approved",
      "step4": "Login to quote & order",
      "emailValidated": "Thank you for validating your email address",
      "processingRequest": "Your account request is being processed, we will be in touch shortly.",
      "requestReceived": "Thank you for your request",
      "emailVerificationSent": "You will shortly receive an email to validate your email address.",
      "haveAccount": "Got an Account?",
      "signIn": "Sign In"
    },

    "dashboard": {
      "text": "Hi {name}...",
      "description": "Welcome to your {company} {license}",
      "addCustomer": "Add Customer",
      "allowMoreCustomers": "Allow more customers to quote & order.",
      "resources": "Resources",
      "brochures": "Brochure & Guides",
      "helpGuides": "Help Guides",
      "helpDocs": "{touch} Support Documents",
      "knowledgeBase": {
        "store": "{touch} Store",
        "enquire": "Enquire Now",
        "hideArticle": "Hide Article",
        "undoHide": "Please visit the {0} to undo this change.",
        "link": "Account Page",
        "articles": {
          "title0": "{0} Setup Checklist",
          "title1": "How to Buy {1}",
          "title2": "{1} Setup Guide",
          "title3": "Deploying {1}",
          "title4": "Increase Sales with {1}",
          "title5": "Consumer Website Theme",
          "title6": "Trade Website Theme",
          "title7": "Bespoke Website",
          "title8": "{2}"
        }
      },
      "checklist": {
        "setupChecklistLabel": "Setup Checklist",
        "setupChecklistDescription": "Click a section below to jump directly to it.",
        "step1": "1. Add you company details and logo ",
        "step2": "2. Add your team members",
        "step3": "3. Personalise your paperwork",
        "step4": "4. Choose how you want to price",
        "step4b": "At this point you are ready to start quoting",
        "step5": "{step}. Setup {brandedModeDesigner}",
        "step5b": "At this point you can generate leads on your website, social channels or show rooms."
      }
    },

    "kpi": {
      "daysAgo": "Last {days} Days",
      "ordersPlaced": "Orders Placed",
      "quotesCreated": "Quotes Created",
      "enquiries": "{retail} Enquiries",
      "generatedByYou": "generated by you",
      "topX": "Top {number}",
      "enquiriesTitle": "Enquiries",
      "quotes": "Quotes",
      "quoted": "Quoted",
      "orders": "Orders",
      "ordered": "Ordered",
      "period": "Period"
    },

    "enquiries": {
      "upgrade": "Upgrade",
      "dealerText": "Generate consumer enquiries to pass to your customers to facilitate.",
      "upgradeDescription": "To upgrade to {retail} contact the BM Group sales team on",
      "refusalReason": "Refusal Reason",
      "convertToQuote": "Convert to Quote",
      "goToQuote": "Go to Quote",
      "details": "Enquiry Details",
      "enquiryNumber": "Enquiry Number",
      "refusalQuestion": "Why are you refusing this enquiry?",
      "refusalPlaceholder": "Enter refusal reason...",
      "unableToDelete": "Unable to delete",
      "cannotDeleteLastJob": "Cannot delete last job in contract",
      "businessSearchPlaceholder": "Search enquiries by consumer details or postcode..",
      "consumerDetails": "Consumer Details",
      "noConsumerFound": "No Consumer Record Found",
      "enquiryRejected": "Enquiry Rejected",
      "referral": "Referral",
      "selfGenerated": "Self Generated",
      "enquiryOverdue": "Enquiry Overdue",
      "assign": "Assign Enquiry",
      "assignToCustomer": "Assign Enquiry To Customer",
      "assigned": "Assigned",
      "consumerNotFound": "Consumer not found",
      "assignedTo": "Assigned to",
      "leadCaptureEnquiries": "{brandedMode} Enquiries",
      "filterByCompanyName": "Filter by company name...",
      "dealerNetworkPartnerOnly": "Dealer Network Partner Only",
      "lastAssigned": "Last Assigned",
      "customerIsOnStop": "{name} is On Stop.",
      "assignToCustomerConfirm": "Are you sure you want to assign an enquiry to this customer?",
      "assignToNameConfirm": "Are you sure you want to assign an enquiry to {name}?",
      "leadCapture": {
        "title": "Generate Consumer Enquiries",
        "text": "{retail} allows you to generate your own enquiries on your website, social channels and in your showroom.",
        "subtext": "Includes Home Visualiser",
        "button": "Setup {retail}"
      }
    },

    "quotesAndOrders": {
      "searchPlaceholder": "Search for reference...",
      "newOrder": "New Order",
      "orderStatus": "Order Status",
      "expiryStatus": "Expiry Status",
      "portalVisibility": "Portal Visibility",
      "quoteStage": "Quote Stage",
      "quoteStages": "Quote Stages",
      "viewQuote": "View Quote",
      "lockedByUser": "This order is locked by you",
      "confirmation": "Confirmation",
      "customerNotes": "Customer Notes",
      "internalNotes": "Internal Notes",
      "saveProblem": "A problem occurred while saving this job. Please re-input the job details.",
      "saveRetryWait": "Please wait {minutes} {unit} before retrying to save this job",
      "saveError": "Sorry, there was a problem saving this job",
      "release": "Release",
      "noDownloads": "No Downloads",
      "featureUnavailableTitle": "Feature unavailable",
      "featureUnavailableText": "Please contact support; Create Order Is Not Available",
      "onStopTitle": "Customer Status - On Stop",
      "onStopText": "Orders cannot be placed for this account please speak to your fabricator",
      "newQuote": "New Quote",
      "quoteStatus": "Quote Status",
      "viewOrder": "View Order",
      "customerQuote": "Customer Quote",
      "sendCustomerQuote": "Send Customer Quote",
      "accountNotActiveTitle": "This account is not active, please contact your fabricator",
      "quotePdf": "Quote PDF",
      "createTest": "Create Test",
      "selectSandbox": "Select Sandbox",
      "quoteNumber": "Quote {number}",
      "orderNumber": "Order {number}",
      "ordersTitle": "{orderStatus} Orders",
      "financialSummary": "Financial Summary",
      "calculationBreakdown": "Calculation Breakdown",
      "cancelOrder": "Cancel Order",
      "cancelOrderConfirmTitle": "Are you sure? The cancellation cannot be undone.",
      "cancelOrderRiskText": "I understand that once cancelled this order cannot be uncancelled and wish to continue cancelling the order.",
      "backDoNotCancel": "Back (do not cancel)",
      "acceptToView": "<Accept to view>",
      "noConsumer": "No Consumer",
      "clickToAddDetails": "Click to add details",
      "editCustomer": "Edit Customer",
      "adjustPrice": "Adjust Price",
      "requoteCustomer": "Re-quote Customer",
      "discountAppliedToItem": "The discount code <u>{code}</u> has been applied to an item in this order.",
      "discountAppliedToSubtotal": "The discount code <u>{code}</u> has been applied to the subtotal of this order.",
      "subtotalManuallyUpdated": "The subtotal has been manually updated",
      "priceManuallyUpdated": "The price of an item has been manually updated.",
      "fabricatorReports": "Fabricator Reports",
      "generatingFabricatorReports": "Generating Fabricator Reports",
      "downloadGlassOrder": "Download Glass Order",
      "downloadWorksOrder": "Download Works Order",
      "downloadCuttingList": "Download Cutting List",
      "downloadPanelOrder": "Download Panel Order",
      "downloadBayBowsLayout": "Download Bay/Bows Layout",
      "downloadMultisegmentWorksOrder": "Download Multisegment Works Order",
      "reportsNotAvailableForOldJobs": "This feature is available on jobs processed after {date}.",
      "contractTypeDetails": "{contractType} Details",
      "quoteNumberLabel": "Quote Number",
      "customerPO": "Customer PO",
      "fitting": "Fitting",
      "supplyAndFit": "Supply & fit",
      "supplyOnly": "Supply Only",
      "quotedBy": "Quoted By",
      "issuesAcknowledged": "Issues Acknowledged",
      "isExpired": "This {contractType} is expired",
      "unlocking": "Unlocking {contractType}",
      "refreshContract": "Refresh {contractType}",
      "isLocked": "This {contractType} is locked",
      "isLockedBy": "This {contractType} is locked by {firstName} {lastName} - {email}",
      "unlock": "Unlock {contractType}",
      "unsubscribedProductsTitle": "Some products in this {contractType} are no longer on your subscription",
      "unsubscribedProductsText": "These items are highlighted below and the {contractType} cannot be saved until they are removed from the basket.",
      "noNotes": "No Notes.",
      "noteAlreadyUpdated": "{title} has already been updated. Please refresh to see changes.",
      "downloadName": "Download {name}",
      "generatingName": "Generating {name}",
      "bodyText": "Body Text",
      "emailNotification": "Email Notification",
      "sendEmailNotification": "Send Email Notification",
      "quoteCustomer": "Quote your customer",
      "quoteCustomerSubtext": "Create your customer quote by adding your sell price below",
      "yourCost": "Your Cost",
      "yourSellingPrice": "Your selling price (exc VAT)",
      "marginOnProducts": "Margin On Products",
      "margin": "Margin",
      "supplierNotes": "Supplier Notes",
      "editProducts": "Edit Products",
      "convertToOrder": "Convert to Order",
      "unableToDelete": "Unable to delete",
      "cannotDeleteLastJob": "Cannot delete last job in contract",
      "confirmDeleteJob": "Are you sure you want to delete this job?",
      "pleaseEnterConsumerDetails": "Please enter consumer details",
      "consumerDetailsEmailText": "You can send an email to the consumer once their details have been entered",
      "confirmCustomerOrder": "Confirm Customer Order",
      "placedPaymentPending": "Placed (Payment Pending)",
      "placedPaymentFailed": "Placed (Payment Failed)",
      "placedPaymentSuccessful": "Placed (Payment Successful)",
      "location": "Location",
      "colourExternal": "Colour (External)",
      "colourInternal": "Colour (Internal)",
      "measurements": "Measurements"
    },

    "switchDesign": {
      "chooseAProduct": "Choose a product",
      "noProductsMatch": "No Products match \"{search}\"",
      "noProductsToShow": "No Products to show",
      "selectDesign": "Select a {name} design",
      "noDesignsMatch": "No {name} Designs match \"{search}\""
    },

    "chooseProduct": {
      "partsListNotEnabledTitle": "Parts List Processing is not enabled",
      "partsListNotEnabledText": "Please contact {email} to activate this feature. If you've already purchased it, log out and log back in to apply the license.",
      "createDesign": "Create Design",
      "squaresQuantity": "Squares Quantity",
      "noProductsAvailable": "No Products Available",
      "noCategoriesAvailable": "No Categories Available",
      "noGroupsAvailable": "No Groups Available",
      "searchPlaceholder": "Search for an extra....",
      "noExtrasInCategoryTitle": "No stock extras in this category",
      "noExtrasInCategoryText": "Parts only appear here once they've been marked as available as an extra in your Parts List.",
      "manageInPartsList": "Manage in Parts List",
      "allDesignsViewedFromOutside": "ALL DESIGNS VIEWED FROM OUTSIDE",
      "poweredBy": "Products and data powered by",
      "noGroupsFoundTitle": "No Groups Found",
      "noGroupsFoundText": "{companyName} needs to set up at least 1 Product Group and 1 Product Type",
      "noDesignsAvailable": "No designs available",
      "stageSelectBlurb": "Please select for STAGE {stage}",
      "stageTitle": "STAGE {stage}",
      "stageSelectProduct": "Please select a {name}",
      "chooseGroup": "Choose Group",
      "chooseType": "Choose Type",
      "chooseProduct": "Choose Product",
      "chooseStyle": "Choose Style",
      "chooseVarProduct": "Choose {product}",
      "addToBasket": "Add to Basket"
    },

    "designer": {
      "editComponents": "Edit Individual Components",
      "finishedEditingComponents": "Finished Editing Components",
      "sandboxWarning": "YOU ARE NOW PROCESSING IN {name} SANDBOX",
      "editMeasurements": "Edit Measurements",
      "customiseProduct": "Customise Product",
      "illustrationDisclaimer": "Images are for illustration purposes only and are not to scale",
      "quickTipTitle": "Quick Tip",
      "quickTipText": "Click on areas of the image to customise specific parts of the product. Clickable areas include frame, glass and others parts of this product.",
      "quickTipExample": "For example, select the glass to change its type, add decoration spacers, or more.",
      "saveToType": "Save To {contractType}",
      "saveToBasket": "Save To Basket",
      "noSpecsFoundTitle": "No specifications found",
      "noSpecsFoundText": "Setup specifications for the following products before proceeding",
      "noSpecsFoundTextCallUs": "Please call <a href=\"tel:{phone}\" class=\"underline\">{phone}</a> to set up specifications for this product before proceeding",
      "setupNow": "Setup Now",
      "setupProduct": "Setup Product",
      "noSelection": "No Selection",
      "invalidatedOptionsTitle": "Some options were invalidated",
      "invalidatedOptionsText": "Please review following options",
      "removeItemTitle": "Are you sure you want to remove this item?",
      "itemDeleted": "Item deleted",
      "selectWhereToApply": "Select where to apply the change",
      "issuesClickForDetails": "{count} issues, click for details.",
      "invalidatedOptionsMessage": "Last change caused some previous options to be invalidated. Click here for details",
      "issueInformation": "Information",
      "issueWarning": "Warning",
      "issueRestriction": "Restriction (fabricator authorisation required)",
      "issueProhibition": "Prohibition",
      "changeFrameDesigns": "Change Frame Designs",
      "externalView": "External",
      "internalView": "Internal",
      "internalExternalView": "Internal/External View",
      "threeDVisualisation": "3D VISUALISATION",
      "selectedExtras": "Selected Extras",
      "chooseExtra": "Choose Extra",
      "addExtra": "Add Extra",
      "editExtra": "Edit Extra",
      "addExtraToItem": "Add extra to Item",
      "noExtrasSelected": "No extras selected",
      "selectedStockExtras": "Selected Stock Extras",
      "chooseStockExtra": "Choose Stock Extra",
      "addStockExtra": "Add Stock Extra",
      "noStockExtrasSelected": "No stock extras selected",
      "supplyDimensionsBeforeSaving": "You must supply dimensions before saving",
      "previousQuestion": "Previous Question",
      "nextQuestion": "Next Question",
      "finishDesigning": "Finish Designing",
      "switchProduct": "Switch Product",
      "switchProductText": "Would you like to go back and select a different product?",
      "yesDeleteProduct": "Yes, and delete my current product",
      "yesSaveProduct": "Yes, but save my current product",
      "fullScreenImage": "Full Screen Image",
      "showMenus": "Show Menus",
      "viewProduct": "View Product",
      "viewOptions": "View Options",
      "showXView": "Show {label} View",
      "maxLengthError": "{label} must be {maxLength} characters or less.",
      "searchByOptionName": "Search by option name...",
      "noFilter": "No Filter",
      "addedToBasket": "Added to basket",
      "pleaseSelect": "Please Select...",
      "noOptionSelected": "No Option Selected",
      "advancedSelectionsWillReset": "Your advanced selections will be reset",
      "notMadeRequiredSelections": "You have not made required selections",
      "reviewRequiredQuestions": "Please review and answer the following questions",
      "pleaseSpecify": "Please Specify",
      "optionallyOverride": "Optionally override {value} default",
      "atLeastMm": "at least {min}mm",
      "upToMm": "up to {max}mm",
      "dimensionRange": "{min}mm - {max}mm",
      "minimumIs": "{description} minimum is {min}mm",
      "maximumIs": "{description} maximum is {max}mm",
      "modelError": "3D Model Error",
      "modelErrorText": "There was an error loading the 3D model viewer. Please refresh the page and try again.",
      "deleteProductTitle": "Delete Product",
      "deleteProductText": "Are you sure you want to delete this product?",
      "customDesigner": {
        "stepOf": "Step {current} of {total}",
        "overallWidth": "Overall Width",
        "overallHeight": "Overall Height",
        "customShape": "Custom Shape",
        "windowPreview": "Window preview will appear here",
        "invalidShape": "Invalid Shape",
        "tabSizes": "Sizes",
        "tabShape": "Shape",
        "tabTransomsMullions": "Transoms/Mullions",
        "tabOpeners": "Openers",
        "tabDummiesMidrails": "Dummies/Midrails",
        "tabSubOpeners": "Sub-openers",
        "tabCreateDesign": "Create Design",
        "descSizes": "Enter the overall width and height of your design in millimetres. This defines the base size of your design.",
        "descShape": "Select a standard shape relating to your measurements or create your own by enabling Custom Shape and dragging points on the grid.",
        "descTransomsMullions": "Choose where you'd like to add transoms or mullions by clicking on any horizontal or vertical line. Select as many as required to create your design.",
        "descOpeners": "Select an opening type from the dropdown, then click on a square in the grid to apply it. Repeat the process with different opener types until all required openers are set.",
        "descDummiesMidrails": "Select Dummy or Midrail from the dropdown, then click on a horizontal or vertical line in the grid to apply it. Repeat the process if you want to add more.",
        "descSubOpeners": "Select a sub-opener type from the dropdown, then click within a dummy or midrail section to add it. This allows you to create smaller opening sections inside larger areas.",
        "descCreateDesign": "If you're happy with your design, click submit to generate your design."
      }
    },

    "basket": {
      "addExtras": "Add Extras",
      "editExtras": "Edit Extras",
      "addAnotherProduct": "Add Another Product",
      "addProduct": "Add Product",
      "openVirtualHome": "Open Virtual Home",
      "addDimensionsRequired": "You are required to add dimensions",
      "itemsHaveIssuesTitle": "There are issues with some of your items",
      "itemsHaveIssuesText": "Please review your items with issues before continuing.",
      "removeItemTitle": "Are you sure you want to remove this item?",
      "itemDeleted": "Item deleted",
      "orderOnHoldTitle": "Order on hold",
      "orderOnHoldText": "To formally place the order use the Confirm Customer Order button in the order page.",
      "orderOnHoldPaymentText": "To formally place the order use the Confirm Customer Order button in the order page and pay for the order at checkout.",
      "saveUnavailableTitle": "Save unavailable",
      "saveUnavailableText": "Remove unsubscribed products before saving.",
      "placeOrder": "Place Order",
      "saveProducts": "Save Products",
      "measurements": "Measurements",
      "addExtra": "Add Extra",
      "addExtraToJob": "Add Extra To Job",
      "updateExtra": "Update Extra",
      "noExtrasSelected": "No extras selected",
      "jobPrice": "Job Price",
      "itemPrice": "Item Price",
      "removePriceTooltip": "Remove {price}",
      "editPriceTooltip": "Edit {price}",
      "overridePriceTitle": "Override {price}",
      "customerCurrencyLabel": "Customer Currency ({code})",
      "localCurrencyLabel": "Local Currency ({code})",
      "overridingJobPriceNote": "Overriding the price will ignore individual item prices.",
      "overridingItemPriceNote": "Changes made will be reflected in the job level price.",
      "overridingQuantityNote": "Value entered will be divided by the item quantity.",
      "overridingDeliveryNote": "Delivery charges will be calculated at checkout.",
      "overridingCurrencyNote": "The customer currency is applied for this contract.",
      "overrideJobPriceTitle": "Overriding Job Price will Reset All Item Prices",
      "overrideItemPriceTitle": "Overriding Item Price will Reset Job Price",
      "deleteOverrideTitle": "Are you sure you want to delete this price override?",
      "fitting": "Fitting",
      "supplyOnly": "Supply Only",
      "supplyAndFit": "Supply & Fit",
      "sizingWarningText": "This enquiry was supplied without measurements.",
      "sizingWarningInstructions": "Once you have entered real dimensions for <strong>all products</strong>, please click the button below to remove this warning.",
      "markAsMeasured": "Mark as measured",
      "partsList": "Parts List",
      "partNumber": "Part No. {code}: {description}",
      "deleteStockItemConfirm": "Delete this stock item?",
      "qtyInvalid": "Qty must be a number greater than zero",
      "unsubscribedProductWarning": "This product is no longer available on your subscription. Remove it from the basket before saving.",
      "location": "Location",
      "size": "Size",
      "externalColour": "External Colour",
      "internalColour": "Internal Colour",
      "hardwareColour": "Hardware Colour",
      "glazing": "Glazing",
      "extrasTitle": "Product Extras",
      "perItem": "per item",
      "each": "each",
      "voucherCode": "Voucher Code",
      "voucherPlaceholder": "Enter a voucher code for this {type}....",
      "applyVoucher": "APPLY",
      "voucherApplied": "Voucher Code Applied",
      "applyVoucherPrompt": "Apply voucher code to this {type}?",
      "voucherAlreadyAppliedTitle": "A Voucher code is already applied",
      "voucherAlreadyAppliedText": "Are you sure you want to override this code?",
      "deleteItem": "Delete Item",
      "editItem": "Edit Item",
      "duplicateItem": "Duplicate Item",
      "viewSummary": "View Summary",
      "viewIssues": "View Issues",
      "issues": "Issues",
      "savingWarning": "Please do not click back or refresh button.",
      "noItems": "No basket items to display",
      "designAProduct": "Design a Product",
      "getAQuote": "Get a Quote",
      "unsavedTitle": "You have an unsaved {type} in the basket",
      "unsavedTitleDifferentCustomer": "You have an unsaved {type} in the basket for a different customer",
      "unsavedText": "Clicking continue will delete and override the {type} in the basket.",
      "viewBasket": "View Basket",
      "leaveTitle": "Are you sure you want to leave?",
      "leaveText": "Leaving now will remove this contract from the basket",
      "backToBasket": "Back To Basket",
      "makeEnquiry": "Make an enquiry",
      "makeEnquiryAndSaveVis": "Make an enquiry and save your visualisation",
      "completeFormBelow": "Please complete the simple form below.",
      "notesLabel": "Enter any notes here",
      "consentNonDealer": "Tick the box to confirm that you agree for the information you have provided to be passed to us, we will contact you to discuss your items.",
      "consentDealer": "Tick the box to confirm that you agree for the information you have provided to be passed to a local installer, who will contact you to discuss your items.",
      "submitEnquiry": "Submit Enquiry",
      "saveToEnquiry": "Save To Enquiry",
      "thanksEnquiry": "Thank you for making an enquiry.",
      "whatHappensNext": "What happens next?",
      "enquirySummaryEmail": "You will receive an instant email containing a summary of your enquiry.",
      "enquirySummaryVisEmail": "You will receive an instant email containing a summary of your enquiry and visualisation of your home.",
      "dealerContact": "One of our trusted dealers will contact you shortly.",
      "teamContact": "A member of our team will contact you shortly.",
      "enquirySummaryDealerNetwork": "You will receive an e-mail containing a summary of your enquiry and we will pass your details and requirements to local members of our installer network to offer you an indicative quotation for the supply and installation of your desired products.",
      "enquirySummaryCheckEmail": "You will receive an instant email containing a summary of your enquiry. Don't forget to check you spam folder unfortunately that's where it may end up. Once we have reviewed your enquiry a member of our team will contact your shortly",
      "priceSubjectToSurvey": "Price subject to survey and technical specification",
      "designMoreProducts": "Design more products",
      "extrasSearch": "Extras Search",
      "extraAdded": "{description} added",
      "showFullBasket": "Show Full Basket",
      "noItemsInBasket": "No Items in Basket.",
      "addItem": "Add Item"
    },

    "checkout": {
      "orderReviewTitle": "3. Order Review",
      "sectionRequired": "You must complete this section to continue.",
      "privacyConsent": "Before ticking this box, please {clickHere} for more information about how we will use your personal information. By ticking this box you confirm that you understand and agree to our {privacyPolicy} and {termsAndConditions}.",
      "basketItem": "Basket showing {qty} item",
      "basketItems": "Basket showing {qty} items",
      "deliveryAddressSection": "1. Delivery Address",
      "deliveryDateSection": "2. Requested Delivery Date and Notes",
      "requestedDeliveryDate": "Requested Delivery Date",
      "deliveryNotes": "Delivery Notes",
      "supplierNotes": "Supplier Notes",
      "poNumber": "PO Number",
      "actionRequiredTitle": "Action Required",
      "actionRequiredText": "Please setup a delivery address and at least one delivery day to enable your license.",
      "setupDelivery": "Setup Delivery",
      "redirectingToPayment": "Redirecting to payment gateway",
      "placingOrderPendingPayment": "Placing order as pending payment",
      "placingYourOrder": "Placing your order",
      "discountCode": "Discount ({code})",
      "logOrderWith": "Log Order With {name}",
      "makePayment": "Make Payment",
      "placeOrderPendingPayment": "Place Order as Pending Payment",
      "chargeToAccountWith": "Charge to Account With {name}",
      "pendingPaymentTitle": "Order will be marked as 'Placed (Pending Payment)'",
      "pendingPaymentText": "Customer will need to login and pay for the order.",
      "noDeliveryAddresses": "No delivery addresses available."
    },

    "news": {
      "title": "Latest News",
      "newPost": "New Post",
      "content": "Content",
      "savePost": "Save News Post",
      "manageCategories": "Manage Categories",
      "addCategory": "Add Category",
      "categoryName": "Category Name",
      "editCategory": "Edit Category",
      "categoryNameMissing": "Category Name Missing",
      "categoryNameMissingText": "Please enter a category name.",
      "deleteCategoryTitle": "Are you sure you want to delete this category?",
      "titleRequired": "Please choose a Title for this post",
      "categoryRequired": "Please choose a Category",
      "summaryRequired": "Please write a summary for this post",
      "contentRequired": "Post content cannot be blank",
      "imageRequired": "Please choose an image",
      "deletePostText": "Are you sure you want to delete this news post?",
      "searchPlaceholder": "Search news...",
      "noMatchSearch": "No News Articles match \"{search}\"",
      "noArticles": "No News Articles to show"
    },

    "marketing": {
      "addNewFile": "Add New File",
      "addNewVideo": "Add New Video",
      "editFile": "Edit File",
      "editVideo": "Edit Video",
      "addCategory": "Add Category",
      "editCategory": "Edit Category",
      "categoryName": "Category Name",
      "saveCategory": "Save Category",
      "visibleTo": "Visible to?",
      "allCustomers": "All Customers",
      "leadCapturePartnerOnly": "{brandedMode} Partner Only",
      "fileUrl": "File URL",
      "videoUrl": "Video URL",
      "searchPlaceholder": "Search marketing materials...",
      "noDocumentsMatch": "No Documents match \"{search}\"",
      "categoryEmpty": "This category is empty",
      "confirmDeleteItem": "Are you sure you want to delete this item?",
      "confirmDeleteCategory": "Are you sure you want to delete this category?",
      "openExternalLink": "You are about to open an external file link",
      "openExternalLinkText": "Would you like to proceed to open the following url address?",
      "noCategoryChosen": "No Category Chosen",
      "pleaseChooseCategory": "Please choose a Document Category.",
      "noFileChosen": "No File Chosen",
      "pleaseChooseFile": "Please choose a File or add a file URL.",
      "pleaseChooseVideoCategory": "Please choose a Video Category",
      "pleaseAddVideoId": "Please add a video id",
      "unsupportedVideoUrl": "We only support youtube or vimeo URLs.",
      "pleaseAddVideoUrl": "Please add a video url"
    },

    "costsPrices": {
      "setupPricing": "How would you like to set up your pricing?",
      "setupPricingDescription": "Select between quick pricing for simple jobs or advanced pricing for accurate itemised pricing.",
      "quickPricing": "Once you create a quote or convert an enquiry into one, simply open the quote details page and click 'Adjust Price'. This lets you set a job price without completing the full advanced pricing setup.",
      "quickSetupImage1Alt": "Pricing breakdown with button showing how to adjust price",
      "quickSetupImage2Alt": "Pop up after clicking adjust price showing field to enter new price",
      "pricingOverlapWarning": "Pricing can overlap when values are configured in both Parts List <b>(per part)</b> and in Product, Glass, Panel or Slab <b>(per option)</b>. To keep totals accurate and predictable, apply each pricing rule in one place only.",
      "strategy1Title": "Strategy 1: Cost + Markup",
      "strategy1Description": "Build prices automatically from your costs and markup percentages.",
      "strategy1Step1": "Set up {financialCategories} and markup percentages",
      "strategy1Step2PerOption": "Add costs per option and assign financial categories in {product}, {glass}, {panel}, and {slab} pages",
      "strategy1Step2PerPart": "Add costs and assign financial categories per part in {partsList}",
      "strategy1Step3": "Add {labour} costs and assign financial categories",
      "strategy2Title": "Strategy 2: Direct Pricing",
      "strategy2Description": "Enter fixed prices yourself with no markup calculation.",
      "strategy2Step1PerOption": "Add prices per option in {product}, {glass}, {panel}, and {slab} pages",
      "strategy2Step1PerPart": "Add prices per part in {partsList}",
      "strategy2Step2": "Add {labour} prices",
      "advancedPricing": {
        "line1": "Advanced Pricing gives you full control over your job costing. It also allows you to design a product and live-price it in real time. Any enquiries generated through the {brandedModeDesigner} will be automatically priced once converted to a quote.",
        "line2": "Once you setup advanced pricing it can still be overidden with adjust price feature used for quick pricing.",
        "line3": "To complete your Advanced Pricing setup, you'll need to configure:"
      },
      "startPricingSetup": "See tabs above to start your pricing setup",
      "costMarkupTooltip": "Value entered will affect Cost + Markup pricing methods only",
      "wastageTooltip": "Value entered will affect wastage calculated on all bill of material items",
      "selectMultipleBy": "Select multiple by",
      "warningActivePricingMethods": {
        "line1": "If you have active pricing methods within the tabs above, adding prices here won’t replace existing pricing. Methods will combine. Update this section and remove/disable other methods to avoid incorrect totals.",
        "line2": "This section adds another pricing method. If you already have pricing configured elsewhere (e.g., Cost+Markup (Parts List) or Grids (Cost List/Price List), those prices will not be replaced - they will work in conjunction and may stack. To use this method as the single source of truth, update here first and then manually remove/disable the other methods. Otherwise, incorrect prices may be shown in quotes and orders."
      },
      "possibleCombinedPricing": "If you have other pricing methods enabled. Saving here will not replace them and may change final prices due to combined methods.",
      "moveFinancialItemsWarning": "Please move all financial items out of this group before you delete it.",
      "moveFinancialItemsConfirmation": " Are you sure you want to move {from} to {to}?",
      "extraSettingsUnavailable": "Extra settings can only be applied to parts marked as an extra. Turn on 'Extra' for the selected parts, or deselect the ones that aren't available as an extra.",
      "greaterThan": "<u>{corner}</u> must be <strong>greater than or equal</strong> to other corners",
      "lessThanOrEqualTo": "<u>{fieldKeyA}</u> must be <strong>less than or equal</strong> to <u>{fieldKeyB}</u>",
      "greaterThanOrEqualTo": "<u>{fieldKeyA}</u> must be <strong>greater than or equal</strong> to <u>{fieldKeyB}</u>",
      "atLeastOneEnabled": "You must leave at least 1 product enabled",
      "editPricingForCustomers": "Edit Pricing For Customers",
      "editPriceFor": "Edit {description}",
      "partialSave": "Partial Save",
      "pricesSplitInto": "For this category prices are split into:",
      "stepCannotBeZero": "Step cannot be zero or empty",
      "tooManyMatrixSteps": "Increase the step value to reduce the number of steps in the matrix view. Current number of steps: {current}, maximum allowed: {max}",
      "deleteGroupConfirm": "Are you sure you want to delete this group?",
      "deleteItemConfirm": "Are you sure you want to delete this item?",
      "editPriceName": "Edit {description} {name}",
      "selectPrice": "Select {description} Configuration",
      "setBasePrices": "Set Base Prices",
      "upliftBasePrices": "Uplift Base Prices",
      "basePrice": "Base Price: {width} x {height}",
      "widthIncrement": "Width Increment",
      "heightIncrement": "Height Increment",
      "allSizesNote": "All sizes entered in grid apply to all styles; even where limitations are exceeded",
      "unsavedChangesTitle": "You will lose unsaved changes, are you sure?",
      "unsavedListChanges": "Your edits on this list will be lost",
      "unsavedGridChanges": "Your edits on this grid will be lost",
      "failedToLoadGrid": "Failed to load Grid",
      "failedToSetCell": "Failed trying to set {cell} box",
      "labels": {
        "addItem": "Add Item",
        "addExtra": "Add Extra",
        "groups": "Groups",
        "addGroup": "Add Group",
        "saveGroup": "Save Group",
        "fittingCost": "Fitting Cost",
        "fittingMarkup": "Fitting Markup",
        "surveyCost": "Survey Cost",
        "surveyMarkup": "Survey Markup",
        "supplyMarkup": "Supply Markup",
        "unitOfMeasure": "Unit of Measure",
        "listPrice": "List Price",
        "listCost": "List Cost",
        "markup": "Markup",
        "wastage": "Wastage",
        "override": "Override",
        "minimumAreaForCosting": "Minimum Area for Costing",
        "minimumAreaForPricing": "Minimum Area for Pricing",
        "nonRectangularPremium": "Non-Rectangular Premium",
        "minHeight": "Minimum Height",
        "maxHeight": "Maximum Height",
        "minWidth": "Minimum Width",
        "maxWidth": "Maximum Width",
        "minHeightShort": "Min Height",
        "maxHeightShort": "Max Height",
        "minWidthShort": "Min Width",
        "maxWidthShort": "Max Width",
        "width": "Width",
        "height": "Height",
        "unit": "Unit",
        "length": "Length",
        "cutToSize": "Cut to Size",
        "area": "Area",
        "perimeter": "Perimeter",
        "volume": "Volume",
        "baseFrameCost": "Base Frame Cost",
        "topLeftCost": "Top Left Cost",
        "topRightCost": "Top Right Cost",
        "bottomLeftCost": "Bottom Left Cost",
        "bottomRightCost": "Bottom Right Cost",
        "baseFramePrice": "Base Frame Price",
        "topLeftPrice": "Top Left Price",
        "topRightPrice": "Top Right Price",
        "bottomLeftPrice": "Bottom Left Price",
        "bottomRightPrice": "Bottom Right Price",
        "baseSashCost": "Base Sash Cost",
        "baseSashPrice": "Base Sash Price",
        "topLeft": "Top Left",
        "topRight": "Top Right",
        "bottomLeft": "Bottom Left",
        "bottomRight": "Bottom Right",
        "allCorners": "All Corners",
        "otherCorners": "Other Corners",
        "jointCornerSquareWeld": "Joint Corner Square Weld",
        "jointCornerSquareMech": "Joint Corner Square Mech",
        "jointCornerAngledWeld": "Joint Corner Angled Weld",
        "jointCornerAngledMech": "Joint Corner Angled Mech",
        "jointTSquareWeld": "Joint T Square Weld",
        "jointTSquareMech": "Joint T Square Mech",
        "jointTAngledWeld": "Joint T Angled Weld",
        "jointTAngledMech": "Joint T Angled Mech",
        "jointButtWeld": "Joint Butt Weld",
        "jointButtMech": "Joint Butt Mech",
        "jointCruciformWeld": "Joint Cruciform Weld",
        "jointCruciformMech": "Joint Cruciform Mech",
        "jointCillWeld": "Joint Cill Weld",
        "jointCillMech": "Joint Cill Mech",
        "cornerJointSquare": "Corner Joint Square",
        "cornerJointAngled": "Corner Joint Angled",
        "tJointAngled": "T Joint Angled",
        "tJointSquare": "T Joint Square",
        "buttJoint": "Butt Joint",
        "cruciformJoint": "Cruciform Joint",
        "cillJoint": "Cill Joint",
        "opener": "Opener",
        "fixed": "Fixed",
        "glazing": "Glazing",
        "beading": "Beading",
        "ancillary": "Ancillary",
        "reinforcing": "Reinforcing",
        "band": "Band",
        "sashOverlap": "Sash Overlap",
        "weight": "Weight",
        "groupName": "Group Name",
        "quickPricing": "Quick Pricing",
        "advancedPricing": "Advanced Pricing",
        "noMarkupToPrice": "No Mark Up To Price",
        "financialCategory": "Financial Category",
        "discountCategory": "Discount Category",
        "profileColour": "Profile Colour",
        "per": "Per",
        "warningActivePricingMethods": "Warning - Active Pricing Methods",
        "customerPrices": "Customer Prices",
        "partName": "Part Name",
        "itemColour": "Item Colour",
        "itemCode": "Item Code",
        "globalPrice": "Global Price",
        "customerPrice": "Customer Price",
        "basePrice": "Base Price",
        "baseCost": "Base Cost",
        "priceFromCostsPlusMarkup": "Price From Cost Plus Mark Up",
        "general": "General",
        "frame": "Frame",
        "sash": "Sash",
        "colours": "Colours",
        "hardware": "Hardware",
        "profiles": "Profiles",
        "simulateCostMatrix": "Simulate Cost Matrix",
        "simulatePriceMatrix": "Simulate Price Matrix",
        "costMatrix": "Cost Matrix",
        "priceMatrix": "Price Matrix",
        "possibleCombinedPricing": "Possible Combined Pricing",
        "types": "Types",
        "patterns": "Patterns",
        "spacerBars": "Spacer Bars",
        "decorations": "Decorations",
        "gasFill": "Gas Fill",
        "fanHoles": "Fan Holes",
        "designs": "Designs",
        "backingGlass": "Backing Glass",
        "numerals": "Numerals",
        "knockers": "Knockers",
        "letterplates": "Letterplates",
        "spyholes": "Spyholes",
        "doorDesigns": "Door Designs",
        "doorGlass": "Door Glass",
        "doorColour": "Door Colour",
        "decorativeGlassDesign": "Decorative Glass Design",
        "items": "Items",
        "grids": "Grids",
        "lists": "Lists",
        "financialGroups": "Financial Groups",
        "addNewGroup": "Add New Group",
        "searchItemPlaceholder": "Search for an item to edit a {type}...",
        "upliftSelected": "Uplift Selected",
        "modifySelected": "Modify Selected",
        "upliftCost": "Uplift Cost",
        "upliftPrice": "Uplift Price",
        "wholeNumber": "Whole Number",
        "roundToWholeNumber": "Rounding to whole number",
        "keepTwoDecimals": "Keeping 2 decimal places",
        "uplift": "Uplift",
        "netPrice": "Net",
        "copyTo": "Copy To",
        "copiedFrom": "Copied From",
        "copyProductTo": "Copy {productName} to...",
        "weld": "Weld",
        "mech": "Mech",
        "angled": "Angled",
        "units": "Units",
        "joint": "Joint",
        "aperture": "Aperture",
        "piece": "Piece",
        "rates": "Rates",
        "part": "Part",
        "perOption": "Per option",
        "perPart": "Per part",
        "addOptions": "Add Options",
        "optionName": "Option Name",
        "useProductMeasurements": "Use Product Measurements",
        "useProductMeasurementsTooltip": "Select this to price by product measurements, you will not be able to override the sizing",
        "measurePerM": "Per m",
        "measurePerM2": "Per m²",
        "measurePerM3": "Per m³",
        "each": "Each",
        "perKg": "Per KG",
        "percentage": "Percentage",
        "perMeter": "Per Metre",
        "list": "List",
        "grid": "Grid",
        "editList": "Edit List",
        "editGrid": "Edit Grid",
        "viewColourGroups": "View Colour Groups",
        "extra": "Extra",
        "extraPrice": "Extra Price",
        "extraFinancialCategory": "Extra Financial Category",
        "extraDiscountCategory": "Extra Discount Category"
      }
    },

    "productSettings": {
      "sourceOverlaps": "Source Overlaps",
      "sourceClearances": "Source Clearances",
      "weldAllowances": "Weld Allowances",
      "cutType": "Cut Type",
      "allowance": "Allowance",
      "fixedGlass": "Fixed Glass",
      "sashGlass": "Sash Glass",
      "addGroup": "Add Group",
      "editGroup": "Edit Group",
      "addType": "Add Type",
      "editType": "Edit Type",
      "groups": "Groups",
      "types": "Types",
      "fittingCostPerProduct": "Fitting Cost / Product",
      "fittingCostPerChildProduct": "Fitting Cost / Child Product",
      "optionHeading": "Option Heading",
      "optionItem": "Option Item",
      "currentDefault": "Current Default",
      "mainDefault": "Main Default",
      "newDefault": "New Default",
      "noDefault": "No Default",
      "noOptionsAvailable": "No options available",
      "selectDefault": "Select a default",
      "subscriptionType": "Subscription Type",
      "availableToOrder": "Available to Order",
      "availableInLeadCapture": "Available in {brandedMode}",
      "catalogueProducts": "Catalogue Products",
      "sourceOverlapsTooltip": "Profiles with a source clearance of <b>{value}mm</b>",
      "sourceClearancesTooltip": "Profiles with a source clearance of <b>{value}mm</b>",
      "disabledHint": "This option is not configurable in setup but not yet active.",
      "pendingHint": "This option is configurable in setup but not yet active.",
      "enabledHint": "This option is configurable in setup and active.",
      "mandatoryHint": "This option will always be active."
    },

    "paymentGateway": {
      "setupIncomplete": "Setup Incomplete",
      "setupIncompleteHint": "If you have already completed the setup, Stripe may still be finalising your account. Please wait a few moments and then refresh this page.",
      "manageAccount": "Manage Account",
      "accountIdentifier": "Account Identifier",
      "accountStatus": "Account Status",
      "displayName": "Display Name",
      "firstDataManaged": "Your Payment Gateway is managed by First Data. No further action required.",
      "noStripeAccountFound": "No Stripe account found",
      "createAccount": "Create Account"
    },

    "delivery": {
      "leadTime": "Lead Time",
      "minimumOrderValue": "Minimum Order Value",
      "latitudeLongitudeRequired": "Latitude & Longitude are required for geographical selection via enquiries.",
      "addressSearch": "Address Search",
      "addressManual": "Address 1 (Manual mode - auto-complete deactivated)",
      "enterAddressManually": "Enter address manually",
      "address1": "Address 1",
      "address2": "Address 2",
      "address3": "Address 3",
      "longitude": "Longitude",
      "latitude": "Latitude",
      "adjustCoordinates": "Adjust Coordinates",
      "saveCoordinates": "Save Coordinates",
      "postCodeAreas": "Postcode Areas",
      "postCodeAreaList": "Postcode Area List",
      "postCodeAreaPlaceholder": "Add post code prefix...",
      "postCodeAreaMultiple": "Enter comma seperated list of postcode areas",
      "deliveryDate": "Delivery Date",
      "deliveryType": "Delivery Type",
      "deliveryDays": "Delivery Days",
      "deliveryNotes": "Delivery Notes",
      "deliveryOption": "Delivery Option",
      "noDeliveryDaysSelected": "No Delivery Days Selected",
      "editDeliveryDays": "Edit Delivery Days"
    },

    "account": {
      "discountAmount": "Discount Amount",
      "usesPerAccount": "Uses Per Account",
      "totalUses": "Total Uses",
      "deliveryTitle": "Delivery Addresses & Days",
      "editCompanyDetails": "Edit Company Details",
      "editFinancialDetails": "Edit Financial Details",
      "applyTax": "Apply Tax",
      "applyTaxToRequotes": "Apply Tax to Requotes",
      "requoteTaxValue": "Requote Tax Value",
      "allowProductRequoteMarkups": "Allow Product Requote Markups",
      "linkedBranches": "Linked Branches",
      "taxValue": "Tax Value",
      "companyRegistrationNumber": "Company Registration Number",
      "vatRegistrationNumber": "VAT Registration Number",
      "documentsAndAgreements": "Documents & Agreements",
      "addressesAndDeliveryDays": "Addresses & Delivery Days",
      "hiddenArticles": "Hidden Articles",
      "showArticle": "Show Article",
      "showArticleOnDashboard": "This article will show on the {link}.",
      "allArticlesVisible": "All Articles Visible.",
      "holidays": "Holidays",
      "addHoliday": "Add Holiday",
      "saveHoliday": "Save Holiday",
      "noSavedAddresses": "You have no saved addresses",
      "addTaxRate": "Add Tax Rate",
      "saveTaxRate": "Save Tax Rate",
      "editTaxRates": "Edit Tax Rates",
      "noTaxRatesToShow": "No Tax Rates to Show",
      "deleteThisTaxRate": "Are you sure you want to delete this Tax Rate?",
      "currencies": "Currencies",
      "selectCurrency": "Select Currency",
      "chooseCurrency": "Choose Currency",
      "updateExchangeRates": "Update Exchange Rates",
      "addCurrency": "Add Currency",
      "noCurrenciesToShow": "No Currencies to Show",
      "editCurrencies": "Edit Currencies",
      "makeDefault": "Make Default",
      "addVoucher": "Add Voucher",
      "voucherNote": "Please Note: <b>Vouchers apply to job level</b>",
      "customersLimitedTo": "Customers Limited to",
      "searchPlaceholder": "Search customers...",
      "fixed": "Fixed",
      "amount": "Amount",
      "percentage": "Percentage",
      "workingDays": "Working Days",
      "saveWorkingDays": "Save Working Days",
      "addQuoteStage": "Add Quote Stage",
      "editSettings": "Edit Settings",
      "processingSettings": "Processing Settings",
      "disablePortalProcessing": "Disable Portal Processing",
      "disablePortalProcessingWarning": "Enabling this setting will disable processing for all Portal users",
      "contractValidityPeriod": "Contract Validity Period",
      "contractValidityPeriodTooltip": "The number of days a contract remains valid. Once expired, the contract must be reprocessed to refresh pricing before it can be used again.",
      "activeCustomerPeriod": "Active Customer Period",
      "activeCustomerPeriodTooltip": "Customers who have placed an order within this number of days are counted as active in KPI reports.",
      "sendBccEmail": "Send Bcc Email",
      "bccOrderConfirmations": "Bcc order confirmations",
      "bccOrderConfirmationsTooltip": "When enabled, a copy of every order confirmation email will be sent to the BCC email address specified below.",
      "bccEmailAddress": "Bcc Email Address",
      "approveOrdersWithWarnings": "Approve Orders with Warnings",
      "approveOrdersWithWarningsTooltip": "Users need to approve orders containing items with warning-level issues",
      "issuePresentWarningPlaceholder": "Text to be displayed to obtain approval of orders with items having warning-level issues present",
      "disclaimerText": "Disclaimer Text Required",
      "installationSettings": "Installation Settings",
      "fittingCostJob": "Fitting Cost / Job",
      "kpiSettings": "KPI Settings",
      "pleaseSelectCurrency": "Please select a currency",
      "deleteThisCurrency": "Are you sure you want to delete this Currency?",
      "enterNewLink": "Enter a new link...",
      "voucherLimitedTo": "Limited To",
      "voucherAccountLimit": "Account Limit",
      "voucherUses": "Uses",
      "voucherOutOf": "{current} out of {total}",
      "deleteVoucher": "Are you sure you want to delete {code} voucher?"
    },

    "leadCapture": {
      "hero": {
        "expiringLine1": "Your fabricator",
        "expiringLine2": "supported subscription",
        "expiringLine3": "for {touch} is...",
        "expiringLine4": "Expiring Soon",
        "expiringTag": "Act Now to Stay Online",
        "expiringButtonDescription": "Buy {brandedMode}",
        "activeLine1": "Get the best from",
        "activeLine2": "{brandedMode}",
        "activeList1": "How to generate enquiries",
        "activeList2": "Banners & button ideas",
        "activeList3": "Social media ideas",
        "activeList4": "Plus more...",
        "activeButtonText": "{brandedMode} Tips",
        "activeButtonDescription": "4 Tips on generating enquiries",
        "inactiveLine1": "Don't Miss out!",
        "inactiveLine2": "Generate enquiries with..",
        "inactiveLine3": "{brandedMode}",
        "inactiveButtonText": "Try {brandedMode}",
        "inactiveButtonDescription": "Activate free features",
        "sellMore": "Sell more"
      },
      "company": {
        "enquiryOverdueLimit": "Time Limit for Assigned Enquiries",
        "newAddress": "New Address",
        "selectAddress": "Select Address",
        "requestMeasurements": "Request Measurements",
        "showDesignNames": "Show Design Names",
        "thankYouPageRedirect": "Thank You Page Redirect",
        "iframeRedirect": "Iframe Redirect",
        "contractConfirmation": "All your quote and order confirmations will be sent here.",
        "rejectedEnquiries": "We'll email this address with details of any rejected enquiries.",
        "enquiryOverdueLimitText": "When you assign a {setup} enquire how long will the customer have to action the enquiry. Add a number of hours. If not actioned in this time the enquiry will be available to assign to another customer.",
        "paperwork": "This will be displayed on your paperwork that will be sent to a customer.",
        "requestMeasurementsText": " Would you like to request measurements from your customers via the {setup} Designer? If Yes, this question will appear on the intro screen.",
        "showDesignNamesText": "Choose between Design A or Design B when a customer chooses a product type.",
        "noAddresses": "You have no saved addresses",
        "invalidTag": "Invalid Google Tag",
        "invalidTagHtml": "Please do not enter <strong>G-</strong> as part of the code.",
        "thankYouPageRedirectText": "Redirect customers to a custom url after submitting enquiry form in {setup} Mode.",
        "uploadGdprDocuments": "Upload your GDPR Documents",
        "gdprDocumentsRequired": "These documents are required to comply with GDPR regulations as you will be collecting customer data via {setup} Mode.",
        "designA": "Design A",
        "designB": "Design B",
        "googleAnalytics": {
          "compatibleWith": "Not compatible with deployment 2 (iFrame deployment). Please select deployment 1.",
          "setup": "Setup analytics to measure traffic & conversions in {setup}.",
          "step1": "Provide the gtag code embedded on your website.",
          "step2": {
            "header": "Setup Cross-domain Measurements",
            "text": "Allows activity to be accurately attributed to a single user as they cross domains",
            "part1": "Go to the Google Analytics home page linked to the gtag above.",
            "part2": "In Admin, under Data collection and modification, click Data streams",
            "part3": "Click Web, then click a web data stream",
            "part4": "In the web stream details, click Configure tag settings (at the bottom)",
            "part5": "In the Settings section, click Configure your domains",
            "part6": "Click Add condition under Include domains and set match type to Exactly matches",
            "part7": "Enter the domain for your website, e.g. example.com (without https)",
            "part8": "Repeat step 6 and enter the domain for the designer which is bm-touch.co.uk"
          },
          "step3": {
            "header": "Verify Cross-domain Measurements is Working",
            "part1": "Open a page of your site that contains a link to {setup} Mode.",
            "part2": "Click the link and verify that the URL in the destination domain contains the linker parameter _gl"
          },
          "step4": {
            "header": "Verify Conversion Data is Working",
            "text": "A conversion event will be named enquiry-conversion",
            "part1": "Submit an enquiry",
            "part2": "Go to Google Analytics Realtime report. You should see the event name with at least one conversion next to the name in the card"
          }
        }
      },
      "products": {
        "showToConsumers": "Show to Consumers",
        "showOn": "Show on {setup}",
        "text": "Select which products you sell from the list below, these will then be shown on your {setup} designer",
        "availableInLeadCapture": "Available in {brandedMode}",
        "atLeastOneProductRequired": "You must leave at least 1 product enabled"
      },
      "deployment": {
        "deploy": "Deploy",
        "howToDeploy": "How to Deploy {setup}",
        "copyURL": "Copy URL",
        "copyIframe": "Copy Iframe",
        "deployTooltip": "Click here for instructions on how to deploy {setup} to your website.",
        "aliasTooltip": "Personalise the URL/website address for your {setup}. This is usually your company name.",
        "gdpr": "Please upload your GDPR documents, you will then be able to deploy your designer.",
        "instruction": "Once you have completed the steps above, please click here for instructions on how to {setup}.",
        "subHeader": "How to deploy",
        "option1": {
          "title": "Option 1 - deploy in new window",
          "step1": "1) Click the 'Copy URL' button below.",
          "step2": "2) Add this link onto your website. We recommend linking this up to a button or banner. You can also add a link to the navigation of your website.",
          "step3": "3) Once the links have been added, your {setup} will now be live on your website and any updates you make to your settings will be automatically applied to your live {setup}.",
          "tip": "Tip: This link can also be posted directly to social media to generate further enquiries",
          "recommended": "Recommended"
        },
        "option2": {
          "title": "Option 2 - deploy in iframe",
          "step1": "1) Click the 'Copy iFrame' button below.",
          "step2": "2) Place the code snippet within a container where you want it to appear on your website.",
          "notRecommended": "Not recommended with Google Analytics Integration"
        }
      },
      "setup": {
        "readyToDeploy": "You are now ready to deploy {setup}",
        "companyDetailsAndSettings": "Company Details & Settings",
        "requiredSetup": "* Required Setup",
        "businessDocuments": "Business Documents",
        "businessDocumentsTextBusiness": "To generate enquiries online you must supply a terms and privacy policy.",
        "businessDocumentsTextPortal": "To comply with GDPR you must supply a terms and privacy policy.",
        "manageDetails": "Manage Details",
        "activateProductsTextBusiness": "Activate products for {setup}. These should be products you want homeowners to enquire about.",
        "activateProductsTextPortal": "Activate products for {setup}. These should be products you want to allow your customers to enquire about.",
        "activateYourProducts": "Activate your products",
        "activateProductsTooltip": "These products will match what is available to quote and order.",
        "activateProducts": "Activate products",
        "completeFirstTwoSteps": "In order to setup your {setup} designer you must complete the first 2 steps."
      },
      "styling": {
        "manageStyling": "Manage Styling",
        "instruction": "Edit images and text to personalise {touch} for your business. You can edit various areas including; {setup} intro and enquiry screen, VirtualHome, pdfs and email correspondence to your customers.",
        "landingPageBackground": "{setup} Landing Page Background",
        "landingPageBackgroundLocation": "Location: {setup} designer introduction page {setup}",
        "landingPageBackgroundPurpose": "Purpose: Personalise the landing page for your customers who visit {setup}",
        "landingPageText": "{setup} Landing Page Text",
        "landingPageTitle": "Landing Page Title",
        "landingPageIntro": "Landing Page Intro",
        "landingPageBodyText": "Landing Page Body Text",
        "landingPageTitleDescription": "This will be displayed on the {setup} designer page as the heading on the landing page.",
        "landingPageIntroDescription": "This will be displayed on the {setup} designer page as the sub-heading on the landing page.",
        "landingPageBodyTextDescription": "This will be displayed on the {setup} designer page as the welcome text on the landing page.",
        "virtualHomeBanner": "Virtual Home Banner",
        "virtualHomeBannerLocation": "Location: Basket Page",
        "virtualHomeBannerPurpose": "Purpose: To launch the Virtual Home feature",
        "virtualHomeBackground": "Virtual Home Background",
        "virtualHomeBackgroundLocation": "Location: Virtual Home",
        "virtualHomeBackgroundPurpose": "Purpose: Personalise the background of the Virtual Home feature",
        "thankYouPageBackground": "Thank You Page Background",
        "thankYouPageBackgroundLocation": "Location: {setup} Thank You Page",
        "thankYouPageBackgroundPurpose": "Purpose: Personalise the background of the {setup} Thank You Page",
        "thankYouPageText": "{setup} Thank You Page Text",
        "thankYouPageTitle": "Thank You Page Title",
        "thankYouPageIntro": "Thank You Page Intro",
        "thankYouPageBody": "Thank You Page Body Text",
        "thankYouPageTextDescription": "This will be displayed on the {setup} designer thank you page as the heading on the landing page.",
        "thankYouPageIntroDescription": "This will be displayed on the {setup} designer thank you page as the sub-heading on the landing page.",
        "thankYouPageBodyDescription": "This will be displayed on the {setup} designer thank you page as the welcome text on the landing page.",
        "customerEmail": "Customer Email Confirmation of New {setup} Enquiry",
        "customerEmailReceived": "This is the email that will be sent to your customer to confirm that you have received their enquiry",
        "customerEmailAssignment": "This is the email that will be sent to your customer to confirm when they have been assigned a {setup} enquiry within their portal.",
        "emailSubject": "Email Subject",
        "emailBody": "Email Body",
        "consumerEmail": "Consumer email confirmation of new {setup} being assigned to your designated customer",
        "consumerEmailDescription": "This is the email that will be sent to the consumer to confirm which customer their enquiry has been assigned to.",
        "customText": "Custom Text",
        "enquiryEmailHeaderImage": "Enquiry Email Header Image",
        "enquiryEmailHeaderImageLocation": "Location: The Header of the email receipt the user receives after making an enquiry.",
        "enquiryEmailHeaderImagePurpose": "Purpose: Personalise your paperwork with a photo displaying your product",
        "enquiryPdfImage1": "Enquiry PDF image 1",
        "enquiryPdfImage1Location": "Location: Intro page of the pdf emailed to the homeowner",
        "enquiryPdfImage1Purpose": "Purpose: Personalise your paperwork with a photo displaying your product",
        "enquiryPdfImage2": "Enquiry PDF image 2",
        "enquiryPdfImage2Location": "Location: Outro page of the pdf emailed to the homeowner",
        "enquiryPdfImage2Purpose": "Purpose: Personalise your paperwork with a photo displaying your product",
        "enquiryPdfSummaryFooter": "Enquiry PDF Summary Footer",
        "enquiryPdfSummaryFooterDescription": "The last page of the enquiry PDF, at the bottom of the summary section",
        "FooterTitle": "Footer Title",
        "FooterText": "Footer Text"
      },
      "freeTrial": {
        "redirect": "You are now being redirected to {url} to register for your free trial.",
        "title": "{brandedMode} Free Trial",
        "useAdmin": "{companyBrandedMode} Free Trial can only be activated via your company's Admin Account",
        "subscribePrompt": "To subscribe to {companyBrandedMode} Free Trial, please login to your Admin account with the email(s) below:"
      }
    },

    "retailOptionsControl": {
      "hiddenOptions": "Hidden Options",
      "visibleOptions": "Visible Options",
      "selectedHeading": "Selected Heading",
      "tooltips": {
        "productsFilter": {
          "line1": "Filter to focus on options for a specific product.",
          "line2": "Note: Filtering only changes what is highlighted here. It does not change the saved option order."
        },
        "hiddenOptions": "Add hidden options to the Retail Designer",
        "visibleOptions": "Customise visible options for the Retail Designer",
        "optionItems": "Enable or disable individual options for the Retail Designer"
      }
    },

    "staff": {
      "addStaff": "Add Staff",
      "addStaffMember": "Add Staff Member",
      "editStaffMember": "Edit Staff Member",
      "allowMoreStaff": "Add more staff members to your team.",
      "licenseLimit": "{active} out of {limit} licenses allocated",
      "resendActivation": "Must save user before resending activation",
      "activationEmailResent": "Activation Email Resent",
      "resendActivationEmail": "Resend Activation Email",
      "termsAndConditions": "You must accept the terms and conditions",
      "archivedStaff": "At least one staff member must not be archived.",
      "branchUsersNonAdmin": "Branch users are non-admins",
      "staffLicenses": "Staff Licenses",
      "unlimited": "unlimited",
      "noLicensesAllocated": "No licenses allocated.",
      "licenseLimitReachedTitle": "License Limit Reached",
      "licenseLimitExpressHtml": "You have reached your user license limit. Please vist your {account} to increase your limit.",
      "licenseLimitAccount": "account",
      "licenseLimitExtruder": "You have reached your user license limit. Remove a license from an existing user to continue.",
      "licenseLimitDefault": "You have reached your user license limit. Please contact {fabricator} to increase your limit.",
      "searchPlaceholder": "Search for staff..."
    },

    "styling": {
      "labels": {
        "requoteEmail": "{label} Emails",
        "emailSubject": "Email Subject",
        "emailBodyText": "Email Body Text",
        "quotePDFFirstPageImage": "Quote PDF First Page Image",
        "quotePDFLastPageImage": "Quote PDF Last Page Image",
        "quotation": "Quotation",
        "requote": "Re-quote",
        "metaTitle": "Meta Title",
        "primaryLoginImage": "Primary Login Image",
        "loginPageBackgroundImage": "Login Page Background Image",
        "portalLoginPageText": "Portal Login Page Text",
        "loginHeader": "Login Header",
        "loginSubHeader": "Login Sub Header",
        "loginBodyText": "Login Body Text"
      },
      "tooltip": {
        "emailAddress": "This is the email address where your {label} will be sent from.",
        "emailSubject": "Personalise the subject line for {label} emails that are sent to consumers.",
        "emailBodyText": "Personalise the message in your email, this could be a nice welcoming message or terms and conditions of the {label}.",
        "quotePDFFirstPageImage": "This will be displayed on the first page of the quote PDF.",
        "quotePDFLastPageImage": "This will be displayed on the last page of the quote PDF.",
        "metaTitle": "Meta tags are used to provide additional information about a page to search engines and are displayed within the tab title.",
        "primaryLoginImage": "This is the primary image that is displayed on your {touch} Portal login page where your customers will login.",
        "loginPageBackgroundImage": "This is the background image that is displayed on your {touch} Portal login page where your customers will login.",
        "portalLoginPageText": "This is the text displayed on your {touch} Portal login page where your customers will login.",
        "loginHeader": "This will be displayed on the Portal login page as the heading text.",
        "loginSubHeader": "This will be displayed on the Portal login page as the sub-heading text.",
        "loginBodyText": "This will be displayed on the Portal login page as welcome text underneath the headers."
      }
    },

    "store": {
      "moreBenefits": "More Benefits",
      "gotAQuestion": "Got a question about these products?",
      "clickToLiveChat": "Click Here to Live Chat",
      "leadCaptureHeading": "{name} - {price} {perMonth}",
      "leadCaptureDescription": "{brandedMode} is your own lead generation software for use online, in your showroom or a customers home. Powered and linked to your Fabricators ordering Portal.",
      "selectaDescription1": "Generate enquiries online with Connect Window & Door Designer.",
      "selectaDescription2": "For use on your website, in your showroom, a customer's home or social media.",
      "freeForOneMonth": "Free for 1 month.",
      "featureLeadGeneration": "Lead Generation Software",
      "featureOnlineShowroom": "Use online, in showroom or customers home",
      "featureAddPrices": "Add prices to quotes",
      "featureQuoteManagement": "Quote management",
      "featureHomeVisualiser": "Home Visualiser",
      "featurePersonalisedPaperwork": "Personalised Paperwork",
      "featureAccurateProductImagery": "Accurate Product Imagery",
      "viewDemo": "View Demo",
      "buyLeadCapture": "Buy {brandedMode}",
      "paidByFabricatorUntil": "Paid by Fabricator until {date}",
      "subscriptionActive": "Subscription Active",
      "setupDirectDebit": "Setup my Direct Debit",
      "discoverMore": "Discover More",
      "consumerWebsiteTheme": "Consumer Website Theme",
      "consumerWebsiteCost": "{price} one off cost",
      "consumerWebsiteDescription": "A prebuilt Selecta Systems website theme perfectly tailored for the consumer market. Featuring a wide range of fully populated Advanced 70 product pages. Additional upgrades are available.",
      "tradeWebsiteTheme": "Trade Website Theme",
      "tradeWebsiteCost": "{price} one off cost",
      "tradeWebsiteDescription": "Target the trade and installer market using an informative and user friendly Selecta Systems website theme. Featuring a wide range of fully populated Advanced 70 product pages. Additional upgrades are available.",
      "bespokeWebsite": "Bespoke Website",
      "bespokeWebsiteDescription": "Tailored to your unique needs, our custom designs ensure your brand stands out, providing a seamless user experience that drives engagement and growth.",
      "buyEnquireNow": "Buy / Enquire Now",
      "enquireNow": "Enquire Now",
      "viewPortfolio": "View Portfolio",
      "inPartnershipWith": "In partnership with",
      "leadCaptureForInstallers": "{brandedMode} for installers",
      "leadCaptureLiteVersion": "{brandedMode} is a lite version of {fabricator} Designer.",
      "simplifiedInterface": "A simplified interface and fewer options, allowing homeowners to design and generate an enquiry directly with you.",
      "discoverMoreLeadCapture": "Discover more about {brandedMode}",
      "liteInterface": "'Lite' easy to use interface",
      "fullyBranded": "Fully branded to your company",
      "quoteOrderManagement": "Quote & Order Management",
      "beOnlineInMinutes": "Be Online in Minutes",
      "easySetup": "Easy Setup",
      "problemsHeading": "As a business we understand the problems you face.",
      "tabGeneratingEnquiries": "Generating Enquiries",
      "tabClosingASale": "Closing a Sale",
      "tabDatedBrochures": "Dated Brochures",
      "tabLimitedSellingTimes": "Limited Selling Times",
      "theProblem": "The Problem",
      "howLeadCaptureSolves": "How {brandedMode} solves this issue",
      "howLeadCaptureHelps": "How does {brandedMode} help your business?",
      "featureBoostsRetail": "Boosts your retail presence",
      "featureBoostsRetailText": "Improve your online presence by keeping customers on your website longer, improving interactivity, utilize and highlight your {brandedMode} to improve your marketing.",
      "featureAccurateEnquiries": "You can receive more accurate enquiries",
      "featureAccurateEnquiriesText": "Any enquiries you receive via {brandedMode} will built using the same rule base from {fabricator} ordering system this eliminates errors and means homeowners cant make an enquiry for something that can be manufactured.",
      "featureOwnSystem": "You dont need to buy your own system",
      "featureOwnSystemText": "Bespoke lead generation software can cost around {price}, creating accurate data and rules around the product options is costly and time consuming. We have done all the work for you, {brandedMode} is a low cost solution with a huge amount of benefits.",
      "featureNoSalesman": "There's no need for a salesman",
      "featureNoSalesmanText": "{brandedMode} sits on your website 24/7, meaning while you are busy with other important areas of your business you can still be generating enquiries. {brandedMode} is a cost effective member of your team.",
      "featureShowroom": "You can use it in your showroom",
      "featureShowroomText": "Improve the interactivity within your showroom and display your designer on a tablet or interactive screen. Its a powerful marketing tool and can allow customers to design their perfect product without having to trawl through an outdated brochure.",
      "featureReInputOrders": "Removes the need to re-input orders",
      "featureReInputOrdersText": "Any enquiry that you generate via {brandedMode} can be pushed directly to {fabricator} Portal to be converted into a quote. From their you can tweak options and add a price without the need to re-create your customers enquiry.",
      "poweredBy": "{brandedMode} Powered by {fabricator}",
      "mustUsePortal": "{fabricator} must use {portal}",
      "professionalPaperwork": "PROFESSIONAL PAPERWORK",
      "professionalPaperworkDesc": "Stunning Paperwork branded for you",
      "homeVisualiser": "HOME VISUALISER",
      "wowCustomers": "Wow customers & increase sales",
      "visualiserDescription": "Unlike standard visualisers, QUOTILA Visualiser allows homeowners to upload images of every façade of their property, from both inside and out.",
      "oneMonthFree": "{brandedMode} with ONE MONTH FREE",
      "clickToRegister": "Click to register for a price",
      "quoteYourCustomer": "QUOTE YOUR CUSTOMER",
      "quoteHeading": "Increase profit;<br />Add prices to quotes",
      "quotingText": "All enquiries will land in your Portal account with {fabricator}. Simply convert it to a quote and add the price you want to sell it for.",
      "connectedToPortal": "CONNECTED TO {portal}",
      "convertEnquiriesHeading": "Convert enquiries into orders",
      "convertingText": "Once you have sent your priced up quote to your customer you can then convert it to a complete order. This order will then be placed with {fabricator}.",
      "howToBuy": "How to buy {brandedMode}",
      "howToBuyText1": "The process could not be more simple. Once your direct debit has been setup, you can be live on your own website in just minutes.",
      "howToBuyText2": "Remember {brandedMode} comes with one free month and can be cancelled at any time.",
      "buyStep1": "Login to {fabricator} Portal",
      "buyStep2": "Click QUOTILA Store button",
      "buyStep3": "Register for the Store",
      "buyStep4": "Setup your direct debit - No charge 1st month",
      "buyStep5": "Setup with contact details & logo",
      "buyStep6": "Go Live on your website",
      "viewLeadCaptureDemo": "View a {brandedMode} demo",
      "registerForDemo": "Register today to get access to our Free demo.",
      "generatingEnquiriesProblem": "In a packed market place generating enquiries online can be difficult.",
      "generatingEnquiriesSolution": "{brandedMode} helps you standout from the crowd, add it to your website or on social media. Its a great promotional tool helping customers to interact with you.",
      "closingSaleProblem": "A customer may have had any number of quotes from competitors in your area.",
      "closingSaleSolution": "Use {brandedMode} to wow customers with high quality, accurate product imagery and stunning quotation paperwork. They can even see how there products will look with Virtual Home Visualiser.",
      "datedBrochuresProblem": "We all know how expensive and how quickly brochures can become obsolete and don't mention lugging them from home to home.",
      "datedBrochuresSolution": "{brandedMode} is always accurate and up to date and easy to demo on any tablet or laptop.",
      "limitedSellingTimesProblem": "In a world where everyone is in a rush, its difficult keeping peoples attention or getting them what they need instantly.",
      "limitedSellingTimesSolution": "{brandedMode} is instantly accessible via your website and is automated to allow people to play, designs and make enquiries at their leisure.",
      "branchesHeading": "{name} - {price} {perMonth}",
      "branchesTitle": "QUOTILA Branches",
      "perBranchPerMonth": "per branch, per month",
      "branchesDescription": "Got more than one branch? QUOTILA Branches is the ultimate solution for multi-branch businesses. It empowers each location to operate independently with tools for quoting, ordering and customer management.",
      "branchesFeatureLocalQuoting": "Local quoting and ordering",
      "branchesFeatureInStore": "Convenient in-store and phone ordering",
      "branchesFeatureIndependentCustomer": "Independent customer management",
      "branchesFeatureFlexible": "Flexible standalone operations",
      "branchesFeatureDedicated": "Dedicated local support",
      "buyNow": "Buy Now"
    },

    "support": {
      "title": "Customer Support",
      "manageResources": "Manage Resources",
      "manageResourcesDescription": "Allow customers to download marketing collateral; Technical guides, brochures, images, photos & more",
      "manageNews": "Manage News",
      "manageNewsDescription": "Upload news that is viewable by customers in their Portal; Promote products, industry, and company news.",
      "introTitle": "Introduction",
      "exploreKnowledgeBase": "Explore the Knowledge Base",
      "dontShowAgain": "Don't show again",
      "welcomeTitle": "Welcome to {companyName} Quotes & Orders",
      "videosIntro": "Here's a few videos to get you started.",
      "knowledgeBaseDescription": "Visit our Knowledge Base for a whole host of videos explaining every feature of {product}.",
      "visitKnowledgeBase": "Visit Knowledge Base",
      "freeHelpAndSupport": "Free Help & Support"
    },

    "branches": {
      "addBranch": "Add Branch",
      "searchPlaceholder": "Search for branch...",
      "branchName": "Branch Name",
      "branchDetails": "Branch Details",
      "editBranchDetails": "Edit Branch Details",
      "saveBranch": "Save Branch",
      "setPrimary": "Set Primary",
      "setPrimaryBranch": "Set Primary Branch"
    },

    "customers": {
      "leadCapturePartner": "{brandedMode} Partner",
      "addCustomer": "Add Customer",
      "searchPlaceholder": "Search for customer...",
      "accessTier": "Access tier",
      "accessTierIs": "Access tier {is} {status}",
      "fullTierUsage": "Full-tier customers",
      "noLicensesAllocated": "No licenses allocated.",
      "noTaxRatesAvailable": "No tax rates available",
      "customerTypeCannotChange": "Customer Type cannot be changed",
      "saveCustomer": "Save Customer",
      "tradeCustomerDescription": "<strong>Trade Customers</strong> <br> Consumer data is not visible on jobs in Admin. <br> Jobs are marked as Supply Only. <br> Can only access Supply Only extras. <br> Delivery Charges can be applied.",
      "retailCustomerDescription": "<strong>Retail Customers</strong> <br> Consumer data is visible on jobs in Admin. <br> Jobs are marked as Supply & Fit <br> Can access both Supply Only and Supply & Fit extras. <br> Delivery Charges are never applied.",
      "tierNews": "News",
      "tierNewsInfo": "Share company news and announcements with this customer in their portal.",
      "tierResourceCentre": "Resource centre",
      "tierResourceCentreInfo": "Give access to shared documents, brochures and technical files.",
      "tierLeadCapture": "{brandedMode}",
      "tierLeadCaptureInfo": "Lets this customer capture consumer leads and quotes from their own branded site.",
      "tierQuotesAndOrders": "Quotes & Orders",
      "tierQuotesAndOrdersInfo": "Lets this customer build quotes and place orders online.",
      "tierCustomPricing": "Custom Pricing",
      "tierCustomPricingInfo": "Apply customer-specific price lists and discounts instead of standard pricing.",
      "tierFabricatorReports": "Fabricator Reports",
      "tierFabricatorReportsInfo": "Production and sales reporting for your business, enabled for all customers.",
      "tierOptionalAddOn": "Optional add-on",
      "tierLeadCaptureAddOn": "Purchased by your customers or assigned via a {license}.",
      "tierSponsoredLicense": "Sponsored License",
      "tierFabricatorReportsAddOn": "Your business can purchase this from the {store}.",
      "customerDetails": "Customer Details",
      "pricing": "Pricing",
      "productAvailability": "Product Availability",
      "productDefaults": "Product Defaults",
      "customerList": "Customer List",
      "registrationRequests": "Registration Requests",
      "leadCaptureSubscriptions": "{brandedMode} Subscriptions",
      "downloadHistoryTitle": "Download History",
      "contactEmail": "Contact Email",
      "reportType": "Report Type",
      "emailNotFound": "Email not found",
      "licenseUtilisation": "License utilisation",
      "activeRate": "Active customers",
      "quotaUsed": "of {quota} quota used",
      "remaining": "remaining",
      "licensedActive": "of {licensed} customers active",
      "inactive": "inactive",
      "activeRateTooltip": "Customers that had activity in the last <b>{period} {days}</b> are considered active. The number of active days can be changed in setup, accounts.",
      "customerBase": "Customer base",
      "totalCustomers": "Total customers",
      "liveLicensed": "Live (Licensed)",
      "liveUnlicensed": "Live (Unlicensed)",
      "debugCustomer": "Debug Customer",
      "customerEnabled": "Customer Enabled",
      "customerDisabled": "Customer Disabled",
      "paymentWithOrder": "Payment with order",
      "seePriceBreakdown": "See Price Breakdown",
      "useCustomerCharge": "Use Customer Charge",
      "noDiscountsToShow": "No Discounts to Show",
      "editDiscounts": "Edit Customer Discounts",
      "customerStatus": "Customer Status",
      "licenseEnabled": "License Enabled",
      "skipPendingOrderCustomer": "Skip Pending Order (Customer)",
      "skipPendingOrderStaff": "Skip Pending Order (Staff)",
      "unableToSkipSopTitle": "Unable to skip SOP and make payment with order.",
      "unableToSkipSopText": "Payment with order toggle can be found in financial details section.",
      "licenseLimitReached": "License Limit Reached",
      "licenseLimitReachedHtml": "You have reached your QUOTILA Portal Customer License Limit as per your contracted agreement - Please contact {sales} to increase your limit.",
      "extruderLimitReachedHtml": "Please vist your {account} to increase your limit.",
      "licenseLimitAccount": "account",
      "showPriceBreakdown": "Show Price Breakdown",
      "paymentsSetupRequired": "Payments Setup Required.",
      "paymentsSetupRequiredText": "Please contact your account manager to setup payments.",
      "unablePaymentWithOrder": "Unable to make payment with order and skip SOP.",
      "unablePaymentWithOrderText": "Skip SOP toggle can be found in company details section.",
      "defaultTaxRateRequired": "Default Tax Rate Required.",
      "defaultTaxRateRequiredText": "Please select a default tax rate",
      "searchGroups": "Search Groups...",
      "searchHeadings": "Search Headings...",
      "searchItems": "Search Items...",
      "unsavedHeadingChanges": "There are unsaved changes in this Option Heading.",
      "ignoreAndContinue": "Ignore & Continue",
      "sponsoredLicenses": "Sponsored Licenses",
      "totalLicenses": "Total Licenses",
      "designerUrl": "Designer Url",
      "setExpiryDate": "Set Expiry Date",
      "activatedByCustomer": "Activated by customer. The customer would need to cancel {brandedMode} for the fabricator to enable it.",
      "fabricatorEnabled": "Fabricator Enabled",
      "brandedModePromo": "Looking to give your customers an advantage?",
      "brandedModePromoText": "Supporting their {brandedMode} subscriptions is the ideal solution! Activate their subscription for a set period to boost their home enquiries - helping them, helps you!",
      "brandedModePromoCall": "To discuss, call our sales team on {phone}",
      "discoverMore": "Discover More",
      "confirmEnableBrandedMode": "Are you sure you want to <strong><u>enable</u></strong> {brandedMode} for {name}?",
      "confirmDisableBrandedMode": "Are you sure you want to <strong><u>disable</u></strong> {brandedMode} for {name}?",
      "confirmUpdateExpiryDate": "Are you sure you want to update the expiry date to <strong><u>{date}</u></strong> for {name}?",
      "confirmRemoveExpiryDate": "Are you sure you want to remove the expiry date for {name}?",
      "showFocItemsOnly": "Show FOC items only",
      "mustHaveOneProductEnabled": "Must have one product enabled.",
      "atLeastOneProductEnabled": "At least one product must be enabled."
    },

    "launch": {
      "launchHeader": "Find the perfect products to transform your home.",
      "startDesigning": "Start Designing",
      "tradeCustomer": "Trade Customer?",
      "tradeCustomerLink": "Click here for Quote & Ordering",
      "designerUnavailable": "Designer Unavailable.",
      "measurementsYesNo": "Do you have measurements?",
      "yesHint": "If you have measurements and know the size of your required windows and/or doors click {button}",
      "noHint": "If you are just looking to design and make an enquiry click {button}",
      "measurementsAvailable": "I have measurements",
      "measurementsNotAvailable": "I don't have measurements",
      "designUnavailable": "Oops. This design software is temporarily unavailable.",
      "licenseNotActive": "If you are the license holder for this software, your software license is no longer active.",
      "contactSales": "Please contact our sales team to renew your subscription and continue capturing enquiries."
    },

    "visualiser": {
      "noItems": "No items in {basket}.",
      "addItemPrompt": "To visualise a product please add item to {basket}.",
      "referenceImage": "Enter a reference for this image (e.g. Kitchen, Patio)",
      "startVisualising": "Start Visualising",
      "explorePossibilities": "Explore Endless Interior and Exterior Design Possibilities.",
      "uploadStep1": "1. Import multiple photos from your library",
      "uploadStep2": "2. Choose internal or external view",
      "uploadStep3": "3. Visualise every facade of your home",
      "uploadStep4": "4. Resize and rotate your products",
      "uploadStep5": "5. Save to your quote or send to a friend",
      "uploadTips": "Upload tips",
      "uploadTip1": "No less than 1600 pixels wide.",
      "uploadTip2": "High quality and in focus.",
      "uploadTip3": "No larger than 25MB in file size.",
      "uploadTip4": "An unobstructed view",
      "uploadTip5": "Landscape format (wider than tall).",
      "uploadTip6": "Well centered on area of interest.",
      "referenceLabel": "Enter a reference",
      "referencePlaceholder": "E.g. my home, dads house, mams house",
      "rotateDevice": "Rotate device for a better experience.",
      "infoMessage": "To start click the image of your window or door below to add it to the canvas. Drag the corners of the image to re-size. Click the main house image to deactivate the size controls.",
      "newProducts": "Your New Products",
      "homeImages": "Your Home Images",
      "editUploadImages": "Edit / Upload Images",
      "deleteProduct": "Delete Selected Product",
      "visSavedTitle": "Visualisation Saved",
      "visSavedText": "Visualisation Saved to Quote. Please complete your quote as usual."
    }
  }
}
